var _path, _path2, _path3, _ellipse, _path4, _path5, _g, _path6, _path7, _path8, _ellipse2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRateItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 123,
    viewBox: "0 0 129 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.1284 116.515C102.347 116.515 128.466 90.4321 128.466 58.2574C128.466 26.0827 102.347 0 70.1284 0C37.9096 0 11.791 26.0827 11.791 58.2574C11.791 90.4321 37.9096 116.515 70.1284 116.515Z",
    fill: "#303030"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.693 2.9751H38.5278C36.1775 2.9751 33.9235 3.97196 32.2616 5.74639C30.5997 7.52082 29.666 9.92746 29.666 12.4369V89.2876H29.7743V116.275C29.7742 117.317 30.0243 118.341 30.5005 119.251C30.9768 120.16 31.6634 120.924 32.4949 121.47C33.3264 122.016 34.2749 122.325 35.25 122.368C36.2252 122.411 37.1943 122.186 38.065 121.715L67.2005 105.946C67.9944 105.521 68.8701 105.299 69.7581 105.299C70.6462 105.299 71.5219 105.521 72.3157 105.946L102.347 121.831C103.219 122.292 104.186 122.508 105.157 122.458C106.128 122.408 107.071 122.094 107.897 121.546C108.723 120.998 109.404 120.234 109.876 119.326C110.348 118.418 110.595 117.397 110.594 116.359L110.515 89.2876V12.4106C110.508 9.913 109.577 7.51945 107.925 5.7519C106.272 3.98434 104.032 2.98619 101.693 2.9751V2.9751Z",
    fill: "#FEB528"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.467 94.0854L39.5699 120.859L38.6299 119.112L88.527 92.3384L89.467 94.0854Z",
    fill: "#011625"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 70.1311,
    cy: 43.383,
    rx: 28.5481,
    ry: 28.5089,
    fill: "#011625"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.8844 20.328C61.1315 20.328 53.6067 25.5884 50.3113 33.1202C50.0918 33.622 49.5064 33.8511 49.0039 33.6318C48.5013 33.4126 48.2719 32.828 48.4915 32.3261C52.0915 24.098 60.314 18.3447 69.8844 18.3447C70.4328 18.3447 70.8774 18.7887 70.8774 19.3363C70.8774 19.884 70.4328 20.328 69.8844 20.328Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6121 27.2307L75.6273 35.7286C75.7464 35.9805 75.9223 36.1985 76.1399 36.3637C76.3575 36.5289 76.6102 36.6365 76.8764 36.6771L85.8513 38.0291C86.1552 38.0777 86.4402 38.2135 86.6746 38.4213C86.909 38.6292 87.0836 38.9009 87.1789 39.2063C87.2742 39.5116 87.2864 39.8386 87.2143 40.1508C87.1423 40.4631 86.9886 40.7482 86.7705 40.9746L80.2853 47.5874C80.0925 47.7834 79.9483 48.0257 79.8652 48.2931C79.7822 48.5605 79.7628 48.845 79.8088 49.122L81.3427 58.4594C81.3953 58.7786 81.3613 59.1069 81.2445 59.407C81.1277 59.7071 80.9329 59.967 80.682 60.1574C80.4311 60.3477 80.1342 60.4609 79.8249 60.4841C79.5156 60.5073 79.2063 60.4396 78.9319 60.2886L70.9044 55.8703C70.666 55.7397 70.4009 55.6715 70.1318 55.6715C69.8627 55.6715 69.5976 55.7397 69.3592 55.8703L61.3317 60.2886C61.0574 60.4388 60.7484 60.5058 60.4396 60.4822C60.1308 60.4587 59.8344 60.3453 59.584 60.1551C59.3335 59.9649 59.139 59.7053 59.0223 59.4056C58.9056 59.106 58.8715 58.7782 58.9237 58.4594L60.4548 49.122C60.5007 48.845 60.4814 48.5605 60.3983 48.2931C60.3153 48.0257 60.1711 47.7834 59.9782 47.5874L53.493 40.9746C53.275 40.7482 53.1213 40.4631 53.0492 40.1508C52.9771 39.8386 52.9894 39.5116 53.0847 39.2063C53.18 38.9009 53.3546 38.6292 53.589 38.4213C53.8233 38.2135 54.1084 38.0777 54.4123 38.0291L63.3872 36.6682C63.6534 36.6276 63.9061 36.5201 64.1237 36.3549C64.3413 36.1897 64.5172 35.9717 64.6363 35.7198L68.6515 27.2219C68.7912 26.9369 69.0037 26.6979 69.2654 26.5312C69.5271 26.3646 69.8279 26.2769 70.1344 26.2778C70.4409 26.2788 70.7411 26.3683 71.002 26.5364C71.2628 26.7046 71.4739 26.9449 71.6121 27.2307Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3045_4104)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 69.9525,
    cy: 74.9527,
    rx: 25.887,
    ry: 5.53961,
    fill: "#6B6B6B",
    fillOpacity: 0.39
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.023 105.078C17.4829 107.058 16.5649 109.217 15.4943 111.444C15.2853 111.879 15.4698 112.4 15.9051 112.609C16.3407 112.818 16.8641 112.634 17.0734 112.199C18.0885 110.087 18.9448 108.029 20.4073 106.147C20.7032 105.767 20.6332 105.217 20.2506 104.924C19.8694 104.627 19.3187 104.697 19.023 105.078Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.275 98.6938C11.0365 100.431 5.58069 103.235 1.16341 106.552C0.777909 106.842 0.701021 107.39 0.99251 107.773C1.284 108.157 1.83284 108.236 2.21834 107.946C6.48955 104.739 11.766 102.027 16.8306 100.349C17.2888 100.196 17.536 99.7021 17.3824 99.246C17.2288 98.7899 16.7332 98.5412 16.275 98.6938Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9803 94.5691C13.8203 92.4949 9.88051 91.8899 6.17863 91.8644C5.69497 91.8627 5.30124 92.2506 5.29951 92.7299C5.29686 93.2121 5.68747 93.6049 6.16994 93.6093C9.54189 93.6314 13.1418 94.1363 16.0201 96.0249C16.4238 96.2901 16.9669 96.1784 17.2313 95.7775C17.496 95.3768 17.3838 94.8341 16.9803 94.5691Z",
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 122.013,
    cy: 11.8997,
    rx: 2.97893,
    ry: 2.97485,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3045_4104",
    x: 23.3749,
    y: 48.7225,
    width: 93.1555,
    height: 52.4602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.3453,
    result: "effect1_foregroundBlur_3045_4104"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRateItem);
export default __webpack_public_path__ + "static/media/rate-item.a938a0c1183f94b7b148534a27f8d06e.svg";
export { ForwardRef as ReactComponent };